import { createStructuredSelector } from 'reselect'
import classNames from 'classnames'
import featureToggles from 'shared/featureToggles'

import { dashboardReservationsSelector } from '../../selectors'
import Reservation from './Reservation'

import styles from '../styles.module.scss'

const Header = () => (
    <div className={styles.tableHeader}>
        <div className={styles.transaction}>
            <T>dashboard.label.transaction</T>
        </div>
        <div className={styles.type}>
            <T>dashboard.label.type</T>
        </div>
        <div className={styles.location}>
            <T>dashboard.label.location</T>
        </div>
        <div className={styles.start}>
            <T>dashboard.label.range.s.date</T>
        </div>
        <div className={styles.end}>
            <T>dashboard.label.range.e.date</T>
        </div>
        <div className={styles.price}>
            <T>dashboard.label.price</T>
        </div>
        {!featureToggles.caPurchaseFlow && (
            <div className={styles.paymentMethod}>
                <T>dashboard.label.payment.method</T>
            </div>
        )}
        <div className={styles.actions}>
            <T>dashboard.label.receipt</T>
        </div>
    </div>
)

const ReservationsTable = ({ reservations, onSelectReservation }) => (
    <div className={classNames(['table', 'table-hover', 'mt-4', styles.table, styles.reservations])}>
        <Header />
        {reservations.map(id => (
            <Reservation reservationId={id} onClick={onSelectReservation} key={id} />
        ))}
    </div>
)

export default connect(
    createStructuredSelector({
        reservations: dashboardReservationsSelector,
    })
)(ReservationsTable)
